import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]
  static values = { open: { type: Boolean, default: true } }

  toggle() {
    this.openValue = !this.openValue
    this.update()
  }

  update() {
    this.contentTarget.classList.toggle("hidden", !this.openValue)
    this.iconTarget.classList.toggle("rotate-180", !this.openValue)
  }

  connect() {
    this.update()
  }
}
